import { UserCurrentOrganisation } from "../api/models";

export function getPersonalisationUrl(org: UserCurrentOrganisation) {
  return `${window.location.origin}/app/org/${org.uuid}`;
}
